(function() {
  var wrapper = document.getElementById('yf-app');
  if (!wrapper) return;

  var API_BASE = 'https://fitbyglove.com';
  sessionStorage.setItem('glove_from_fit', 'true');
  var sessionId = new URLSearchParams(window.location.search).get('session');

  // Save for return visits
  if (sessionId) {
    localStorage.setItem('glove_session', sessionId);
  } else {
    sessionId = localStorage.getItem('glove_session');
  }

  if (!sessionId || sessionId === '') { showStartFlow(); }

if (sessionId && sessionId !== '') {
    fetch(API_BASE + '/api/session/' + encodeURIComponent(sessionId) + '/results')
      .then(function(res) {
        if (!res.ok) throw new Error('Session not found');
        return res.json();
      })
      .then(function(data) {
        if (!data.recommendations || data.recommendations.length === 0) {
          showStartFlow();
          return;
        }
        renderResults(data);
      })
      .catch(function(err) {
        console.error('Failed to load session:', err);
        showStartFlow();
      });
  }

  function renderResults(data) {
    var titleEl = document.getElementById('yf-title');
    if (data.name) {
      titleEl.textContent = data.name + '\u2019s Edit';
    }

    var recMap = {};
    data.recommendations.forEach(function(rec) {
      if (rec.styleHandle) recMap[rec.styleHandle] = rec;
    });

    var cards = document.querySelectorAll('.yf-card');
    var matchedCards = [];
    var unmatchedCards = [];

    cards.forEach(function(card) {
      var handle = card.dataset.handle;
      var rec = findRecommendation(handle, recMap);
      if (rec) {
        matchedCards.push({ card: card, rec: rec, score: rec.fitScore });
        addBadge(card, rec);
      } else {
        unmatchedCards.push(card);
      }
    });

    var grid = document.getElementById('yf-grid');
    matchedCards.sort(function(a, b) { return b.score - a.score; });
    matchedCards.forEach(function(item) { grid.appendChild(item.card); });
    unmatchedCards.forEach(function(card) { grid.appendChild(card); });

    document.getElementById('yf-loading').style.display = 'none';
    document.getElementById('yf-content').style.display = 'block';
    // Tag cart as coming from Glove fit experience
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { glove: 'true', glove_session: sessionId }
      })
    });
    // Apply 15% discount
    fetch('/discount/GLOVE15');
  // Save recommendations for PDP badges
    var recStore = {};
    data.recommendations.forEach(function(rec) {
      if (rec.styleHandle) recStore[rec.styleHandle] = rec.bestSize;
    });
    localStorage.setItem('glove_recs', JSON.stringify(recStore));
    var resetDiv = document.getElementById('yf-reset');
    if (resetDiv) resetDiv.style.display = 'block';
    var resetBtn = document.getElementById('yf-reset-btn');
      if (resetBtn) {
        resetBtn.addEventListener('click', function() {
          localStorage.removeItem('glove_session');
          localStorage.removeItem('glove_recs');
          window.location.href = '/pages/your-fit';
        });
      }
  }

  function findRecommendation(productHandle, recMap) {
    if (recMap[productHandle]) return recMap[productHandle];
    var handleLower = productHandle.toLowerCase();
    for (var styleHandle in recMap) {
      var styleLower = styleHandle.toLowerCase();
      var parts = styleLower.split('-');
      if (parts.every(function(part) { return handleLower.includes(part); })) {
        return recMap[styleHandle];
      }
    }
    return null;
  }

function addBadge(card, rec) {
    var imageContainer = card.querySelector('.yf-card-image');
    if (!imageContainer) return;

    var badge = document.createElement('div');
    badge.className = 'yf-badge';
    badge.innerHTML = 'Your Size: ' + escapeHtml(rec.bestSize);
    imageContainer.parentNode.insertBefore(badge, imageContainer.nextSibling);
      // Pre-select variant
    var link = card.querySelector('a');
    var variantsData = card.dataset.variants;
    if (link && variantsData) {
      try {
        var variants = JSON.parse(variantsData);
        var sizeKey = rec.bestSize.toLowerCase().trim();
        var variantId = variants[sizeKey];
        if (variantId) {
          link.href = link.href.split('?')[0] + '?variant=' + variantId;
        }
      } catch(e) {}
    }
  }

  function showError() {
    document.getElementById('yf-loading').style.display = 'none';
    document.getElementById('yf-error').style.display = 'block';
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
function showStartFlow() {
    document.getElementById('yf-loading').style.display = 'none';
    document.getElementById('yf-error').style.display = 'none';
    document.getElementById('yf-content').style.display = 'none';
    document.getElementById('yf-start').style.display = 'block';
  }
// Start flow form handling
  var captureForm = document.getElementById('yf-capture-form');
  var skipBtn = document.getElementById('yf-skip-btn');

  if (captureForm) {
    captureForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var name = document.getElementById('yf-input-name').value.trim();
      var email = document.getElementById('yf-input-email').value.trim();
      startGloveFlow(name, email);
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', function() {
      startGloveFlow(null, null);
    });
  }

  function startGloveFlow(name, email) {
    var newSessionId = generateId();

    if (name && email) {
      fetch(API_BASE + '/api/session/customer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: newSessionId, email: email, name: name })
      });
    }

    // Detect device and redirect
    var ua = navigator.userAgent;
    var isIOS = /iPad|iPhone|iPod/.test(ua);
    var appClipUrl = 'https://fitbyglove.com/fit?session=' + newSessionId;

    if (isIOS) {
      window.location.href = appClipUrl;
    } else {
      // Desktop — open modal if available, otherwise show QR
      var fab = document.getElementById('glove-sizing-floating-btn');
      if (fab) {
        fab.click();
      } else {
        // Show inline QR
        document.getElementById('yf-start').innerHTML =
          '<div style="text-align: center; padding: 60px 20px;">' +
          '<h2 style="color: #A30003; font-size: 18px; margin-bottom: 12px;">Grab your phone to get your fit</h2>' +
          '<p style="color: #A30003; font-size: 14px; margin-bottom: 24px;">Scan the QR code with your iPhone to enter the Glove experience.</p>' +
          '<img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(appClipUrl) + '" alt="QR Code" style="margin-bottom: 16px;">' +
          '</div>';
      }
    }
  }

  function generateId() {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < 16; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }
})();